import type { ConfidenceBreakdown, ConfidenceDrivers } from './types'

export function wilsonInterval(correct: number, n: number, z = 1.96): [number, number] {
  if (n <= 0) return [0, 0]
  const p = correct / n
  const z2 = z * z
  const denom = 1 + z2 / n
  const center = (p + z2 / (2 * n)) / denom
  const margin = (z / denom) * Math.sqrt(p * (1 - p) / n + z2 / (4 * n * n))
  return [Math.max(0, center - margin), Math.min(1, center + margin)]
}

export function computeConfidence(drivers: ConfidenceDrivers, weakSignals: string[]): ConfidenceBreakdown {
  // Agreement raises confidence; diversity does NOT
  const weights = {
    evidence_volume: 0.20,
    evidence_relevance: 0.15,
    segment_coverage: 0.15,
    open_ended_depth: 0.10,
    pass_agreement: 0.20,
    recency: 0.08,
    validation_history: 0.07,
    source_diversity: 0.05,
  }

  const score =
    drivers.evidence_volume * weights.evidence_volume +
    drivers.evidence_relevance * weights.evidence_relevance +
    drivers.segment_coverage * weights.segment_coverage +
    drivers.open_ended_depth * weights.open_ended_depth +
    drivers.pass_agreement * weights.pass_agreement +
    drivers.recency * weights.recency +
    drivers.validation_history * weights.validation_history +
    drivers.source_diversity * weights.source_diversity

  const band: 'Low' | 'Medium' | 'High' =
    score >= 0.65 ? 'High' : score >= 0.40 ? 'Medium' : 'Low'

  // Wilson interval over pass_agreement (not accuracy — no ground truth)
  const wilson = wilsonInterval(
    Math.round(drivers.pass_agreement * 7),
    7
  )

  return { score, band, wilson, drivers, weak_signals: weakSignals }
}

export function confidenceBandLabel(ground_truth_present: boolean, band: 'Low' | 'Medium' | 'High'): string {
  if (!ground_truth_present) {
    return `Expected confidence: ${band}`
  }
  return `Confidence: ${band}`
}
